import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';


import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {

    return (
        <CustomTable
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumento',
                    key: 'tipoDocumento',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true
                },
                {
                    title: 'Por Pagar',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'PEN',
                            dataIndex: 'totalSoles',
                            key: 'totalSoles',
                            className: 'child-group',
                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'USD',
                            dataIndex: 'totalDolares',
                            key: 'totalDolares',
                            className: 'child-group',
                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                }
            ]}
        />
    );
}